import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons';
import { Carousel, Col, Image, Row, Skeleton, Tooltip } from 'antd';
import { useRef } from 'react';
import styles from './ImageCarousel.module.css';

const ImageCarousel = (props) => {
  const carouselRef = useRef(null);

  const handleLeftArrow = () => {
    carouselRef.current.prev();
  };

  const handleRightArrow = () => {
    carouselRef.current.next();
  };

  return (
    <Row>
      <Col span={1} className={styles['carousel-arrow']}>
        <LeftCircleOutlined onClick={handleLeftArrow} />
      </Col>
      <Col span={22}>
        <Image.PreviewGroup>
          <Carousel
            autoplay
            dots={false}
            ref={(ref) => {
              carouselRef.current = ref;
            }}>
            {props.images.map((chunk, chunkIndex) => {
              return (
                <div key={chunk}>
                  <Row justify="space-around">
                    {chunk.map((image, linkIndex) => {
                      return (
                        <Col span={4} key={image.title ? image.title : image}>
                          <Tooltip title={image.originalURL ? image.originalURL : image}>
                            <Image
                              width={150}
                              height={150}
                              src={image.linkToScreenshot ? image.linkToScreenshot : image}
                              placeholder={<Skeleton.Image active={true} style={{ width: '150px', height: '150px' }} />}
                            />
                          </Tooltip>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              );
            })}
          </Carousel>
        </Image.PreviewGroup>
      </Col>
      <Col span={1} className={styles['carousel-arrow']}>
        <RightCircleOutlined onClick={handleRightArrow} />
      </Col>
    </Row>
  );
};

export default ImageCarousel;
